'use strict';

blocks.register('waf-action_Editor_Froala', function () {
    return {
        link: function link($block) {
            var $editorInstances = $block.find('[data-field-type="FieldTypeHTML"]');
            var $control = $editorInstances.find('.form-control');
            var deleteUrl = appSettings.appRoot + 'MarketingLetter/DeleteImage';
            var $type = $block.find('[name$="_Type"]');

            var froalaOptions = {
                key: appSettings.froalaEditorLicense,
                toolbarSticky: false,
                disableRightClick: true,
                $object: $control,
                width: 800,
                heightMin: 400,
                heightMax: 600,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', 'insertHR', 'fullscreen', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', 'undo', 'redo', 'clearFormatting', 'html', '|', 'insertToken', 'square-o'],
                imageUploadMethod: 'POST',
                imageUploadURL: appSettings.appRoot + 'MarketingLetter/UploadImage',
                imageManagerLoadURL: appSettings.appRoot + 'MarketingLetter/ImageGallery',
                imageManagerDeleteURL: deleteUrl,
                imageManagerDeleteMethod: "DELETE"
            };

            $.FroalaEditor.DefineIcon("square-o", { NAME: "square-o" });
            $.FroalaEditor.RegisterCommand("square-o", {
                title: 'Add square',
                focus: false,
                undo: false,
                refreshAfterCallback: false,
                callback: function callback() {
                    this.html.insert("□");
                }
            });

            var tockensDataFetch = function tockensDataFetch() {
                var tokensPromise = $.post(appSettings.appRoot + 'MarketingLetter/TokensInfo?type=' + $type.val());
                tokensPromise.done(function (data) {
                    if ($control.data('froala.editor')) {
                        $control.froalaEditor('destroy');
                    }
                    froalaOptions.tokens = data;
                    $control.froalaEditor(froalaOptions).on('froalaEditor.image.removed', function (e, editor, $img) {
                        $.ajax({
                            // Request method.
                            method: "DELETE",

                            // Request URL.
                            url: deleteUrl,

                            // Request params.
                            data: {
                                src: $img.attr('src')
                            }
                        });
                    });
                });
            };
            tockensDataFetch();
            $type.on('change', tockensDataFetch);
        }
    };
});